export default "__VITE_ASSET__x0z_0Z4s__"